var styles = {
  "Container": "_Container_7i430_1",
  "Legend": "_Legend_7i430_5",
  "LegendItem": "_LegendItem_7i430_13",
  "LegendItemComponent": "_LegendItemComponent_7i430_34"
};

export { styles as default };
